import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './shared/auth.intercepter';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LandingComponent } from './home/landing/landing.component';
import { EmpowerFutureComponent } from './home/home-page/empower-future/empower-future.component';
import { NavbarComponent } from './home/navbar/navbar.component';
import { NextGenerationComponent } from './home/home-page/next-generation/next-generation.component';
import { VertualComponent } from './home/home-page/vertual/vertual.component';
import { FlexibleLearningComponent } from './home/home-page/flexible-learning/flexible-learning.component';
import { EnhanceComponent } from './home/home-page/enhance/enhance.component';
import { ExcutiveCoachComponent } from './home/home-page/excutive-coach/excutive-coach.component';
import { ChooseUsComponent } from './home/home-page/choose-us/choose-us.component';
import { FooterComponent } from './home/footer/footer.component';
import { SuccessStoriesComponent } from './home/home-page/success-stories/success-stories.component';
import { AboutusComponent } from './home/about-us/about-us.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LivSessionpageComponent } from './home/liv-sessionpage/liv-sessionpage.component';
import { ProgramsPageComponent } from './home/programs-page/programs-page.component';
import { PlatinumPageComponent } from './home/platinum-page/platinum-page.component';
import { BillingPageComponent } from './billing-page/billing-page.component';
import { GoldPageComponent } from './home/gold-page/gold-page.component';
import { SignupComponent } from './signup/signup.component';
import { LoginComponent } from './login/login.component';
import { HomePageComponent } from './home/home-page/home-page.component';
import { SalesLeadershipCertificatesComponent } from './home/sales-leadership-certificates/sales-leadership-certificates.component';
import { BusinessBuilderComponent } from './home/business-builder/business-builder.component';
import { TermAndConditionsComponent } from './home/term-and-conditions/term-and-conditions.component';
import { BlogsComponent } from './home/blogs/blogs.component';
import { BrochureButtonComponent } from './shared/brochure-button/brochure-button.component';
import { InstructorsComponent } from './home/instructors/instructors.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { HttpClientModule } from '@angular/common/http';
import { CodeConfirmationComponent } from './code-confirmation/code-confirmation.component';
import { LoaderInterceptor } from './shared/loader.interceptor';
import { LoaderService } from './shared/loader.service';
import { LoaderComponent } from './shared/loader/loader.component';
import { CommonService } from './shared/common.service';
import { ToastComponent } from './shared/toast/toast.component';
import { ToastrModule } from 'ngx-toastr';
import { VerifySessionComponent } from './verify-session/verify-session.component';
import { InstructorViewerComponent } from './home/instructor-viewer/instructor-viewer.component';
import { IcfOverviewComponent } from './home/icf-overview/icf-overview.component';
import { FaqComponent } from './home/faq/faq.component';
import { HelpCenterComponent } from './home/help-center/help-center.component';
// import { InstallmentComponent } from './student/installment/installment.component';

// import { SessionComponent } from './session/session.component';

import { SafeUrlPipe } from './shared/pipes/safe-url.pipe';
import { GoldBrochureComponent } from './home/gold-brochure/gold-brochure.component';
import { PlatinumBrochureComponent } from './home/platinum-brochure/platinum-brochure.component';
import { ScrollToTopDirective } from './shared/scroll-to-top.directive';
import { HeaderComponent } from './home/header/header.component';
import { BottomsideComponent } from './home/bottom-side/bottom-side.component';
import { AdminInstuctorLoginComponent } from './admin-instructor-login/admin-instructor.login.component';
import { CommunityComponent } from './home/community/community.component';
import { CommunitySessionSuccessComponent } from './home/community/community-session-verify/community-session-success.component';
import { SessionModalComponent } from './shared/session-modal/session-modal.component';

@NgModule({
  declarations: [
    ScrollToTopDirective,
    AppComponent,
    LandingComponent,
    EmpowerFutureComponent,
    NavbarComponent,
    NextGenerationComponent,
    VertualComponent,
    FlexibleLearningComponent,
    EnhanceComponent,
    ExcutiveCoachComponent,
    ChooseUsComponent,
    FooterComponent,
    SuccessStoriesComponent,
    AboutusComponent,
    LivSessionpageComponent,
    ProgramsPageComponent,
    PlatinumPageComponent,
    BillingPageComponent,
    GoldPageComponent,
    SignupComponent,
    LoginComponent,
    HomePageComponent,
    SalesLeadershipCertificatesComponent,
    BusinessBuilderComponent,
    TermAndConditionsComponent,
    BlogsComponent,
    BrochureButtonComponent,
    InstructorsComponent,
    ForgotPasswordComponent,
    CodeConfirmationComponent,
    VerifySessionComponent,
    // SessionComponent,
    LoaderComponent,
    ToastComponent,
    VerifySessionComponent,
    InstructorViewerComponent,
    // InstallmentComponent,
    SafeUrlPipe,
    GoldBrochureComponent,
    PlatinumBrochureComponent ,
    HeaderComponent,
    BottomsideComponent,
    AdminInstuctorLoginComponent,
    CommunityComponent,
    CommunitySessionSuccessComponent,
    IcfOverviewComponent,
    FaqComponent,
    HelpCenterComponent,
    SessionModalComponent
  ],
  imports: [
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
      progressBar: true,
      progressAnimation: 'increasing',
    }),
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
  ],

  providers: [
    CommonService,
    // LoaderService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
